// material-ui
import {} from '@mui/material'

import { mobileAndTabletCheck } from 'components/utility'

// assets

import CacheLoad from 'components/CacheLoad'
import ModelLoader from 'components/ModelLoader'
import PlaywatchSearch from 'components/PlaywatchSearch'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid

  function main_card(modelList: any): any {
    return (() => {
      if (mobileAndTabletCheck()) {
        return (
          <>
            <CacheLoad>
              <ModelLoader />
              <PlaywatchSearch />
            </CacheLoad>
          </>
        )
      } else {
        return (
          <CacheLoad>
            <>
              <ModelLoader />
              <PlaywatchSearch />
            </>
          </CacheLoad>
        )
      }
    })()
  }

  let output_main_card = main_card(null)

  return output_main_card
}
